import { render, staticRenderFns } from "./LLTable.vue?vue&type=template&id=d2af50ae&scoped=true"
import script from "./LLTable.vue?vue&type=script&lang=js"
export * from "./LLTable.vue?vue&type=script&lang=js"
import style0 from "./LLTable.vue?vue&type=style&index=0&id=d2af50ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2af50ae",
  null
  
)

export default component.exports